import React from 'react';
import ReactDOM from 'react-dom';

import moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './timeframe.css';

import omit from 'lodash/omit';

/*
	Example here for preset react-dates
	https://github.com/airbnb/react-dates/blob/master/examples/PresetDateRangePicker.jsx
*/

class Timeframe extends React.Component {
	constructor (props){
		super(props)

		let focusedInput = null;
	    if (props.autoFocus) {
	    	focusedInput = 'startDate';
	    } else if (props.autoFocusEndDate) {
	    	focusedInput = 'endDate';
	    }		


		this.state = {
			startDate:this.props.initialStartDate, // moment("2018-01-10", "YYYY-MM-DD"), 
			endDate:this.props.initialEndDate,
			lastStartDate:this.props.initialStartDate,
			lastEndDate:this.props.initialEndDate,
			focusedInput:focusedInput
		}
		

		this.onDatesChange = this.onDatesChange.bind(this);
		this.onFocusChange = this.onFocusChange.bind(this);
		this.renderDatePresets = this.renderDatePresets.bind(this);
		this.onPresetDatesChange = this.onPresetDatesChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		const { focusedInput, startDate, endDate } = this.state;

		if (!focusedInput && (startDate != this.props.initialStartDate || endDate != this.props.initialEndDate)){
			if(this.props.onRangeChange != undefined){
				this.props.onRangeChange();
			}
		}
	}

	isSameDay(a, b) {
		// If at least one of date is not moment
		if (!moment.isMoment(a) || !moment.isMoment(b)) {
			return a==b;
		}
			// Compare least significant, most likely to change units first
			// Moment's isSame clones moment inputs and is a tad slow
		return a.date() === b.date() &&
		a.month() === b.month() &&
		a.year() === b.year();
	}

	onDatesChange({ startDate, endDate }){
		this.setState({startDate, endDate})
	}

	onPresetDatesChange({ startDate, endDate }){
		// close the calendar after select
		this.setState({startDate, endDate, focusedInput:false})
	}

	onFocusChange(focusedInput) {
		if (!focusedInput ){
			this.setState({ focusedInput, lastStartDate:this.state.startDate, lastEndDate:this.state.endDate });
		}else{
			this.setState({ focusedInput });
		}
	}

	renderDatePresets() {
    	const { presets, styles } = this.props;
    	const { startDate, endDate } = this.state;

	    return (
	      <div className={"preset-bar"}>
	        {presets.map(({ text, start, end }) => {
	          const isSelected = this.isSameDay(start, startDate) && this.isSameDay(end, endDate);
	          return (
	            <button key={text} type="button" className={"preset btn " + (isSelected ? 'btn-success' : '')} onClick={() => this.onPresetDatesChange({ startDate: start, endDate: end })}
	            >
	              {text}
	            </button>
	          );
	        })}
	      </div>
	    );
	}

	render(){
		const props = omit(this.props, [
      		'autoFocus',
      		'autoFocusEndDate',
      		'initialStartDate',
      		'initialEndDate',
      		'presets',
      		'onRangeChange'
    	]);

		return (			
			<DateRangePicker
			  {...props}
			  startDate={this.state.startDate}
			  endDate={this.state.endDate}
			  onDatesChange={this.onDatesChange}
			  isOutsideRange={(day) => {return !day.isSameOrBefore()}} 
			  focusedInput={this.state.focusedInput}
			  onFocusChange={this.onFocusChange}
			  numberOfMonths={1}
			  renderCalendarInfo={this.renderDatePresets}
			/>
		)


	}
}

export default Timeframe